import React from "react";
import { Badge } from "reactstrap";
import { BaseChipProps } from "../../../../types";
import useChipStyles from "./styles";

const BaseChip: React.FC<BaseChipProps> = (props) => {
  const { colortext, backgroundcolor, label , style} = props;
  const chipStyles = useChipStyles({ colortext, backgroundcolor });
  return (
      <Badge style={{ ...chipStyles.root, ...style }} pill color="">
      {label}
    </Badge>
  );
};

export default BaseChip;
